export function dispatchCommonData(param) {
    return (dispatch, getState) => {
      dispatch({
        type:'COMMON',
        payload: param
      });
    }
}